module.exports = __webpack_public_path__ + "img/31.a86500cd.jpg";